import React from 'react';

import PropTypes from 'prop-types';

export const ReadTime = (props) => {
    const { readTime } = props;

    return (
        <span className="read-time">{readTime} minute read</span>
    );
};

ReadTime.propTypes = {
    readTime: PropTypes.number.isRequired,
};
